import { Settings } from "../settings"
import { AccessApproachConfig } from "../types"

export const HOSTNAME_ANNOTATION = 'external-dns.alpha.kubernetes.io/hostname'
export const TARGET_ANNOTATION = 'external-dns.alpha.kubernetes.io/target'
export const TTL_ANNOTATION = 'external-dns.alpha.kubernetes.io/ttl'

export const getExternalDNSAnnotations = (appAccess: AccessApproachConfig, settings: Settings, type: "service" | "ingress"): { [key: string]: string | undefined } => {
  if (appAccess.externalDomain?.enable && (appAccess.externalDomain.injectResourceType || "ingress") !== type) {
    const hosts = (appAccess.host instanceof Array) ? appAccess.host.join(',') : appAccess.host
    return {
      ...settings.externalDomainAnnotationTemplate,
      [HOSTNAME_ANNOTATION]: hosts,
      [TARGET_ANNOTATION]: appAccess.externalDomain.target,
      [TTL_ANNOTATION]: appAccess.externalDomain.ttl + '',
    }
  } else {
    return {}
  }
}